var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.8973,
    r: 16,
    fill: "#E5EBED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4762 16.8973H21.1429C21.5634 16.8973 21.9048 16.5559 21.9048 16.1353C21.9048 15.7148 21.5634 15.3734 21.1429 15.3734H10.4762C10.0556 15.3734 9.71429 15.7148 9.71429 16.1353C9.71429 16.5559 10.0556 16.8973 10.4762 16.8973Z",
    fill: "#335C6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/minus.c59be926428d98409799a882e2dec8cd.svg";
export { ForwardRef as ReactComponent };